/**
 * Single source of truth for the active competition year on the web
 * surface.
 *
 * Both the portal `CountdownBanner` and the public
 * `PublicCountdownBanner` read every anchor / calendar query through
 * this constant so the year is controlled in exactly one place and
 * both surfaces count down to the same anchor (Requirement 2.7).
 * Mirrors `mobile/app/src/config/competitionYear.ts` verbatim.
 *
 * When the season rolls over (post-2026 pageant), bump this value and
 * every consumer (`useCountdownAnchor`, the countdown banners, etc.)
 * picks up the new year on next render.
 *
 * Why a constant and not a runtime computation:
 *   - Idaho America's competition year does NOT roll over at midnight
 *     Jan 1 — the spring/summer pageant cycle bridges two calendar
 *     years. Deriving the year from `new Date().getFullYear()` would
 *     silently switch reads to a non-existent next-season anchor while
 *     the current season is still active.
 *   - Keeping it explicit also makes property tests deterministic — no
 *     clock-dependent year drift inside fast-check shrinkers.
 *
 * See `.kiro/specs/public-site-countdown-banner/design.md`
 * ("Components and Interfaces" → shared constant) for the binding
 * requirement.
 */
export const COMPETITION_YEAR = 2026;
